<script>
    import SegmentedToggle from "./SegmentedToggle.svelte";

    export let formData;
    export let elements = {};

    export let secondary = false;
    export let formErrors = {};
    export let prepopulated = false;
    export let emailTypoWarning = null;
    export let onAcceptSuggestion = null;
    export let onDismissWarning = null;
    export let onEmailChange = null;
    
    const genderOptions = [
      { label: "Female", value: "F" },
      { label: "Male", value: "M" },
    ];

    let nameKey = secondary ? 'firstname2' : 'firstname';
    let lastNameKey = secondary ? 'lastname2' : 'lastname';
    let emailKey = secondary ? 'email2' : 'email';
    let genderKey = secondary ? 'gender2' : 'gender';

    $: genderIndex = Math.max(0, genderOptions.findIndex(option => option.value === formData[genderKey]));

    function selectGender(event) {
        formData[genderKey] = genderOptions[event.detail.index].value;
    }
</script>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div class="relative pb-4">
          <input
          type="text"
          placeholder="First Name"
          class="w-full p-3 border rounded-lg text-gray-900"
          bind:value={formData[nameKey]}
          bind:this={elements[nameKey]}
          required
          />
          {#if formErrors[nameKey]}
          <p class="text-red-600 text-xs absolute bottom-0">Please add a First Name</p>
          {/if}
      </div>
      <div class="relative pb-4">
        <input
          type="text"
          placeholder="Last Name"
          class="w-full p-3 border rounded-lg text-gray-900"
          bind:value={formData[lastNameKey]}
          bind:this={elements[lastNameKey]}
          required
        />
        {#if formErrors[lastNameKey]}
        <p class="text-red-600 text-xs absolute bottom-0">Please add a Last Name</p>
        {/if}
      </div>
    </div>
  <div class="relative pb-4">
    <input
      type="email"
      placeholder="Email Address"
      class="w-full p-3 border rounded-lg text-gray-900"
      bind:value={formData[emailKey]}
      bind:this={elements[emailKey]}
      on:input={onEmailChange}
      required
      disabled={prepopulated}
    />
    {#if formErrors[emailKey]}
    <p class="text-red-600 text-xs absolute bottom-0">Please add a valid Email</p>
    {/if}
  </div>
  
  <!-- Email typo warning -->
  {#if emailTypoWarning && emailTypoWarning.typoDetected}
    <div class="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-3 flex items-start gap-3 -mt-2 mb-4 shadow-sm">
      <i class="fa-solid fa-triangle-exclamation text-yellow-600 text-lg mt-0.5"></i>
      <div class="flex-1">
        <p class="text-sm text-yellow-900 font-semibold">
          {emailTypoWarning.suggested ? `Did you mean "${emailTypoWarning.suggested}"?` : (emailTypoWarning.message || 'Please double-check your email address')}
        </p>
        <p class="text-xs text-yellow-800 mt-1">Please correct or confirm your email before continuing.</p>
        {#if emailTypoWarning.suggested}
          <div class="flex gap-2 mt-2">
            <button
              type="button"
              on:click={onAcceptSuggestion}
              class="text-xs px-3 py-1.5 bg-yellow-600 text-white rounded-full hover:bg-yellow-700 transition-colors font-medium"
            >
              Use "{emailTypoWarning.suggested}"
            </button>
            <button
              type="button"
              on:click={onDismissWarning}
              class="text-xs px-3 py-1.5 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition-colors"
            >
              Keep "{emailTypoWarning.original}"
            </button>
          </div>
        {:else}
          <button
            type="button"
            on:click={onDismissWarning}
            class="text-xs px-3 py-1.5 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition-colors mt-2"
          >
            Dismiss
          </button>
        {/if}
      </div>
    </div>
  {/if}
  
  <div class="relative pb-4">
    <div class="flex items-center justify-between">
      <span class="text-gray-700"><i class="fa-duotone fa-light fa-venus-mars mx-1 text-2xl" aria-hidden="true"></i>Gender</span>
      <SegmentedToggle options={genderOptions} selectedIndex={genderIndex} on:change={selectGender} /> 
    </div>
  </div>